$(function() {
    $(window).on('resize', function() {
        $('#main').trigger('resized');
    });
});